import React from 'react';
import './LoadingIcon.scss';

const LoadingIcon = () => {
  return <div className="spinner"></div>;
};

export default LoadingIcon;
